export default class Captcha {
	static submit(action = 'submit', data = null) {
		return new Promise((resolve, reject) => {
			return grecaptcha.ready(() => {
				return grecaptcha.execute(captcha.site_key, { action }).then((token) => {
					let body = 'action=submit_captcha&token=' + encodeURIComponent(token);
					if (data) body += `&${new URLSearchParams(data).toString()}`;
					return fetch(site.ajaxurl, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded',
						},
						body,
					})
						.then((res) => res.json())
						.then(({ score, success }) => {
							if (success && score > 0.5) {
								resolve(score);
							} else {
								reject('Captcha failed');
							}
						})
						.catch((error) => console.error(error));
				});
			});
		});
	}
}
